<template>
  <div>
    <v-select
      v-if="!editable"
      ref="select"
      :label="item.label || undefined"
      :placeholder="item.placeholder || undefined"
      :rules="item.rules || []"
      v-model="itemValue"
      :class="item.editable ? 'select-field' : ''"
      :items="item.items || []"
      :required="item.required || false"
      :disabled="item.disabled || false"
      :autocomplete="item.autocomplete || false"
      :combobox="item.combobox || false"
      :search-input.sync="search"
      :item-text="item.item_text || 'text'"
      :item-value="item.item_value || 'value'"
      :prepend-icon="item.prepend_icon || undefined"
      :append-icon="item.append_icon || 'arrow_drop_down'"
      :append-icon-cb="item.append_icon_cb"
      :color="item.color || undefined"
      :cache-items="item.cache_items || false"
      :hide-selected="item.hide_selected || false"
      :no-data-text="(item.add_on_enter && item.no_data_text) ? item.no_data_text : 'No data available'"
      :readonly="item.readonly || false"
      :multiple="item.multiple || false"
      :tags="item.tags || false"
      :mask="item.mask || undefined"
      :dark="item.dark || false"
      :hint="item.hint || undefined"
      @keyup.tab="focusNextField($event)"
      @keyup.enter="onAddItem"
      @keyup="$emit('on-keyup')"
      :chips="item.chips || false"
      :return-object="item.return_object || false"
    >
    </v-select>
  <div v-if="editable" class="input-group input-group--dirty input-group--text-field primary--text" :class="item.required ? 'input-group--required' : ''">
    <label v-if="item.hidden_label === true ? false : true" class="editable">{{ item.label }}</label>
      <v-edit-dialog
        ref="dialog"
        lazy
        class="edit-dialog"
        v-if="!item.disabled"
      >
        <v-tooltip v-if="item.tooltip || false" open-delay="500" right>
          <span :class="item.value_class || ''" slot="activator">{{ getItemText(item) }}</span>
          <span>{{ item.tooltip }}</span>
        </v-tooltip>
        <span v-else>
          {{ getItemText(item) }}
        </span>
        <div slot="input" class="mt-3 title">{{ item.label }}</div>
        <v-select
          slot="input"
          ref="select"
          :label="item.label || undefined"
          :placeholder="item.placeholder || undefined"
          :rules="item.rules || []"
          v-model="itemValue"
          :items="item.items || []"
          :required="item.required || false"
          :disabled="item.disabled || false"
          :autocomplete="item.autocomplete || false"
          :combobox="item.combobox || false"
          :search-input.sync="search"
          :item-text="item.item_text || 'text'"
          :item-value="item.item_value || 'value'"
          :prepend-icon="item.prepend_icon || undefined"
          :append-icon="item.append_icon || 'arrow_drop_down'"
          :append-icon-cb="item.append_icon_cb"
          single-line
          :color="item.color || undefined"
          :cache-items="item.cache_items || false"
          :hide-selected="item.hide_selected || false"
          :no-data-text="(item.add_on_enter && item.no_data_text) ? item.no_data_text : 'No data available'"
          :readonly="item.readonly || false"
          :multiple="item.multiple || false"
          :tags="item.tags || false"
          :mask="item.mask || undefined"
          :dark="item.dark || false"
          :hint="item.hint || undefined"
          @keyup.tab="focusNextField($event)"
          @keyup.enter="onAddItem"
          @keyup="$emit('on-keyup')"
          :chips="item.chips || false"
          :return-object="item.return_object || false"
        >
        </v-select>
      </v-edit-dialog>
      <span class="edit-dialog" v-else>
        {{ getItemText(item) }}
      </span>
    </div>
  </div>

</template>

<script>

'use strict'

export default {

  name: 'VuetifySelect',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: () => ({
    itemValue: '',
    editable: false,
    oldVal: '',
    search: null,
    currentValue: '',
    filteredItems: false
  }),

  created () {
    this.itemValue = this.value || this.itemValue
    this.oldVal = this.itemValue
    this.isEditable()
  },

  watch: {
    itemValue: {
      handler: function (val, oldVal) {
        if (val) {
          this.$emit('on-change', val, oldVal, this.item, this.isValid())
          this.oldVal = this.itemValue
          if (this.$refs.dialog) {
            this.$refs.dialog.isActive = false
          }
        }
      },
      deep: true
    },
    value: {
      handler: function (newVal, oldVal) {
        this.itemValue = newVal
        this.oldVal = oldVal
        this.isEditable()
      },
      deep: true
    },
    search (newVal) {
      if (this.$refs.select) {
        this.filteredItems = this.$refs.select.filteredItems.length > 0
      }
      if (newVal) {
        this.currentValue = newVal
      }
    }
  },

  methods: {
    focusNextField: function (event) {
      this.isEditable()
      if (this.editable && this.item.focusNextOnEnter) {
        if (event.target.form && event.target.form[this.item.index + 1]) {
          event.target.form[this.item.index + 1].focus()
        }
      }
    },
    isValid: function () {
      let isValid = true
      if (this.item.rules) {
        this.item.rules.forEach(rule => {
          let key = this.item.item_value || 'item_value'
          let value = this.itemValue[key] || this.itemValue
          if (rule(value) !== true) {
            isValid = 22222
          }
        })
      }
      this.item.valid = isValid
      return isValid
    },
    isEditable: function () {
      this.editable = (this.item.editable || false) && this.isValid() && this.itemValue !== ''
    },
    getItemText: function (item) {
      if (item.return_object) {
        let prependText = item.prepend_text || ''
        let key = item.item_text || 'item_text'
        let value = typeof this.itemValue[key] !== 'undefined' ? this.itemValue[key] : this.itemValue
        return prependText + value
      }
      this.itemValue = item.value
      return this.itemValue
    },
    onAddItem (event) {
      if (this.item.add_on_enter) {
        this.itemValue = this.currentValue
        this.$emit('on-add-item', this.currentValue, this.oldVal, this.item, this.isValid())
      }
    }
  }
}
</script>

<style lang="sass">
.edit-dialog
  display: block !important
  text-align: left
  height: 31px
  margin: 0
  font-size: 16px
  padding-bottom: 8px
  margin-top: 3px
  color: rgba(0,0,0,0.87)


.select-field
  margin-bottom: -22px
</style>


// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-select.vue